import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.6716 20.5H5.5C4.39543 20.5 3.5 19.6046 3.5 18.5V13.3284C3.5 12.798 3.71071 12.2893 4.08579 11.9142L11.3787 4.62132C12.5503 3.44975 14.4497 3.44974 15.6213 4.62132L19.3787 8.37868C20.5503 9.55025 20.5503 11.4497 19.3787 12.6213L12.0858 19.9142C11.7107 20.2893 11.202 20.5 10.6716 20.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M9.5 16C9.5 16.8284 8.82843 17.5 8 17.5C7.17157 17.5 6.5 16.8284 6.5 16C6.5 15.1716 7.17157 14.5 8 14.5C8.82843 14.5 9.5 15.1716 9.5 16Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
